"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var classNames = require("classnames");
var PropTypes = require("prop-types");
var React = require("react");
var react_1 = require("react");
var patchIcon_1 = require("../../utils/patchIcon");
var PlusIcon_1 = require("../Icons/PlusIcon");
var ArrowRightIcon_1 = require("../Icons/ArrowRightIcon");
var ExpandAnimationComponent_1 = require("../Internal/ExpandAnimationComponent");
var ChevronDownIcon_1 = require("../Icons/ChevronDownIcon");
var propTypes = {
    summary: PropTypes.oneOfType([PropTypes.string, PropTypes.element]).isRequired,
    summaryClassName: PropTypes.string,
    collapsibleClassName: PropTypes.string,
    iconLeft: PropTypes.oneOfType([PropTypes.func, PropTypes.element]),
    iconRight: PropTypes.oneOfType([PropTypes.func, PropTypes.element]),
    isOpen: PropTypes.bool,
    onToggleOpen: PropTypes.func
};
var UnmanagedDetailsWithinContext = /** @class */ (function (_super) {
    __extends(UnmanagedDetailsWithinContext, _super);
    function UnmanagedDetailsWithinContext(props) {
        var _this = _super.call(this, props) || this;
        _this.collapsibleId = props.ergoElements.idGenerator.next();
        return _this;
    }
    UnmanagedDetailsWithinContext.prototype.render = function () {
        var _a = this.props, children = _a.children, summaryClassName = _a.summaryClassName, collapsibleClassName = _a.collapsibleClassName, iconLeft = _a.iconLeft, iconRight = _a.iconRight, isOpen = _a.isOpen, summary = _a.summary, onToggleOpen = _a.onToggleOpen, ergoElements = _a.ergoElements, other = __rest(_a, ["children", "summaryClassName", "collapsibleClassName", "iconLeft", "iconRight", "isOpen", "summary", "onToggleOpen", "ergoElements"]);
        var currentTheme = ergoElements.theme;
        var summaryClassNames = classNames(summaryClassName, 'ee_details__summary', {
            'ee_details__summary--no-border': isOpen
        });
        var collapsibleClassNames = classNames(collapsibleClassName, 'ee_details__collapsible');
        var leftIcon;
        if (iconLeft) {
            leftIcon = patchIcon_1.default(iconLeft, {
                className: 'ee_details__left-icon'
            });
        }
        else if (currentTheme === 'ergo' || currentTheme === 'das' || currentTheme === 'dkv') {
            leftIcon = patchIcon_1.default(ArrowRightIcon_1.default, {
                title: isOpen ? 'Schließen' : 'Öffnen',
                className: classNames('ee_details__left-icon', {
                    'ee_details__left-icon--open': isOpen
                })
            });
        }
        var rightIcon;
        if (iconRight) {
            rightIcon = patchIcon_1.default(iconRight, {
                className: 'ee_details__right-icon'
            });
        }
        else if (currentTheme === '' || currentTheme === 'ergodirekt') {
            rightIcon = patchIcon_1.default(PlusIcon_1.default, {
                width: 20,
                height: 20,
                title: isOpen ? 'Schließen' : 'Öffnen',
                className: classNames('ee_details__right-icon', {
                    'ee_details__right-icon--open': isOpen
                })
            });
        }
        else if (currentTheme === 'ergo-one' || currentTheme === 'dkv') {
            rightIcon = patchIcon_1.default(ChevronDownIcon_1.default, {
                width: 16,
                height: 20,
                title: isOpen ? 'Schließen' : 'Öffnen',
                className: classNames('ee_details__right-icon', {
                    'ee_details__right-icon--open': isOpen
                })
            });
        }
        return (React.createElement(React.Fragment, null,
            React.createElement("button", { type: "button", className: summaryClassNames, onClick: onToggleOpen, "aria-expanded": isOpen, "aria-controls": this.collapsibleId, "aria-label": isOpen ? 'Details schließen' : 'Details öffnen' },
                React.createElement("span", { className: "ee_details__title" },
                    leftIcon,
                    React.createElement("span", null, summary)),
                rightIcon),
            React.createElement(ExpandAnimationComponent_1.default, __assign({}, other, { id: this.collapsibleId, className: collapsibleClassNames, show: isOpen, "aria-hidden": !isOpen, tabIndex: isOpen ? undefined : -1 }),
                React.createElement("div", { className: "ee_details__content" }, children))));
    };
    UnmanagedDetailsWithinContext.propTypes = propTypes;
    UnmanagedDetailsWithinContext.defaultProps = {
        summary: '',
        summaryClassName: undefined,
        collapsibleClassName: undefined,
        iconLeft: undefined,
        iconRight: undefined,
        onToggleOpen: function () {
            /* intentionally empty */
        },
        isOpen: false
    };
    return UnmanagedDetailsWithinContext;
}(react_1.Component));
exports.UnmanagedDetailsWithinContext = UnmanagedDetailsWithinContext;
//# sourceMappingURL=UnmanagedDetailsWithinContext.js.map